export default "__VITE_ASSET__CKhbBkSy__"